import EBarResourcesCTA from './EBarResourcesCTA';

export default EBarResourcesCTA;
